import axios from "axios";
import { getBaseURL } from "../utils/environment";
import { getSessionId, getToken } from "../utils/auth";

let store;

export const injectStore = (_store) => {
  if (_store) {
    store = _store;
  }
};

//axios.defaults.withCredentials=true;
const ecInstance = axios.create({
  baseURL: getBaseURL(),
});

ecInstance.interceptors.request.use(
  async (config) => {
    let accessToken = getToken();
    config.headers = {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "X-Session-Id": getSessionId(),
    };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Response interceptor for API calls
ecInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async function (error) {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      delete axios.defaults.headers.common["Authorization"];
      return ecInstance(originalRequest);
    }
    return Promise.reject(error);
  },
);

export default ecInstance;
